module.exports = __webpack_public_path__ + "static/media/SoukouMincho.6c91bf59.svg";